import { constants, typographyStyles } from "@newsela/angelou";
import { IReadingSkillColor } from "../utils/GuidedHighlighting.constants";
const { colors } = constants;
const { textLObj, heading4Obj, textMObj } = typographyStyles;
const neutral400 = colors.ui.neutral[400];
const neutral25 = colors.ui.neutral[25];

// Styles for indiviual activity panels

export const collapseButton = {
  "& > button": {
    width: "100%",
  },
};

export const panelWrapperCss = {
  display: "flex",
  flexDirection: "column" as const,
  height: "auto",
};

export const headerWrappercss = (backgroundColor: string) => ({
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center" as const,
  justifyContent: "space-between" as const,
  padding: "24px",
  gap: "24px",
  background: `#${backgroundColor}`,
  position: "relative" as const,
  width: "100%",
});

export const badgeCss = (color: string) => ({
  backgroundColor: color + " !important",
  padding: "4px 8px !important",
  width: "fit-content",
});

export const titleCss = {
  margin: 0,
  ...heading4Obj,
};

export const textCss = {
  margin: 0,
  ...textLObj,
};

export const iconCss = {
  position: "absolute" as const,
  width: "104px",
  height: "80px",
  bottom: "-40px",
  right: "20px",
  zIndex: "99",
};

export const smallRewardWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center" as const,
  position: "relative" as const,
  gap: "4px",
};

export const smallRewardIconCss = {
  width: "24px",
  height: "24px",
  color: "#17786C",
  "& > circle": {
    fill: "#17786C",
    stroke: "#17786C",
  },
};

export const smallRewardText = {
  fontSize: "16px",
  fontWeight: "700",
  color: "#17786C",
  display: "flex",
  padding: "6px",
  backgroundColor: "white",
  borderRadius: "8px",
};

export const correctRewardWrapper = {
  position: "absolute" as const,
  right: "20px",
  bottom: "20px",
};

export const floatingText = {
  position: "absolute" as const,
  top: "-40px",
  right: "0px",
  zIndex: "99",
  fontSize: "24px",
  fontWeight: "700",
  color: "#17786C",
  backgroundColor: "white",
  padding: "8px",
  borderRadius: "8px",
};

export const rewardIconCss = {
  width: "104px",
  height: "80px",
  bottom: "-60px",
  right: "0px",
  zIndex: "98",
  position: "absolute" as const,
  color: "#17786C",
};

export const answerModuleWrapper = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "24px",
  padding: "24px",
  alignItems: "flex-start" as const,
  justifyContent: "center" as const,
};

export const moduleHeaderWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center" as const,
  gap: "8px",
};

export const moduleHeaderText = {
  ...textLObj,
  fontWeight: "bold" as const,
  margin: 0,
};

export const isCorrectWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  alignItems: "center" as const,
  gap: "8px",
};

export const isCorrectText = {
  ...textLObj,
  fontWeight: "400" as const,
  margin: 0,
  color: "#424147",
};

export const isCorrectIcon = (isCorrect: boolean) => ({
  width: "24px",
  height: "24px",
  color: isCorrect ? "#17786C" : "#C32113",
  "& > circle": {
    fill: isCorrect ? "#17786C" : "#C32113",
    stroke: isCorrect ? "#17786C" : "#C32113",
  },
});

export const moduleText = {
  ...textMObj,
  color: neutral400,
  margin: 0,
};

export const attemptWrapper = {
  display: "flex",
  flexDirection: "column" as const,
  padding: "16px",
  alignItems: "flex-start" as const,
  alignSelf: "stretch" as const,
  borderRadius: "8px",
  background: neutral25,
};

export const highlightedTextStyle = (readSkill: IReadingSkillColor | null) => ({
  backgroundColor: readSkill?.color ?? neutral25,
  padding: readSkill ? "8px" : "16px",
  margin: 0,
  color: readSkill?.color ? "#424147" : neutral400,
  ...textLObj,
  textDecoration: readSkill ? "underline" : "none",
  textDecorationColor: readSkill?.BadgeColor,
});

export const highlightedTextStyleValidation = (isCorrect: boolean) => ({
  backgroundColor: isCorrect ? "#d3fbf2" : "#FEEAF9",
  color: "#424147",
  padding: "8px",
  margin: 0,
  textDecoration: "underline",
  textDecorationColor: isCorrect ? "#17786C" : "#DA2C81",
  ...textLObj,
});

export const buttonsWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  gap: "16px",
  alignItems: "center" as const,
  justifyContent: "center" as const,
  width: "100%",
  "& > div": {
    width: "100%",
  },
};

export const buttonCss = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
